import api from '../services/api';
import Swal from 'sweetalert2';

export default function MobiLight() {
  const container = document.createElement('div');
  container.className = 'content';

  // Header
  const header = document.createElement('div');
  header.className = 'card';
  header.innerHTML = `<h2>MobiLight</h2>`;
  container.appendChild(header);

  // Actions
  const actions = document.createElement('div');
  actions.className = 'card inline';
  actions.innerHTML = `
    <input id="filtroMobi" class="form-input" placeholder="Filtrar por nº série ou tipo..." />
    <button id="btnCarregarMobi" class="btn btn-sm">Carregar</button>
    <button id="btnNovoMobi" class="btn primary btn-sm">Novo</button>
  `;
  container.appendChild(actions);

  // Grid
  const grid = document.createElement('div');
  grid.className = 'card';
  grid.innerHTML = `
    <table class="table">
      <thead>
        <tr>
          <th>Nº Série</th>
          <th>Tipo</th>
          <th>Total Terapias</th>
          <th>Total Horas</th>
          <th>Empresa</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody id="tbMobi"></tbody>
    </table>
  `;
  container.appendChild(grid);

  async function carregar() {
    const filtro = container.querySelector('#filtroMobi').value;
    const res = await api.get('/mobilight', { params: { filtro } });
    const tbody = grid.querySelector('#tbMobi');
    tbody.innerHTML = res.data.map(m => `
      <tr>
        <td>${m.numero_serie}</td>
        <td>${m.tipo_descricao}</td>
        <td>${m.total_terapias || 0}</td>
        <td>${m.total_horas || 0}</td>
        <td>${m.empresa_nome  || '-'}</td>
        <td>
          <button class="btn btn-sm edit" data-id="${m.cod_mobi_light}"><i class="fa-solid fa-pen"></i> Editar</button>
          <button class="btn btn-sm link vincular" data-id="${m.cod_mobi_light}">    <i class="fa-solid fa-link"></i> Vincular Empresa  </button>
          <button class="btn btn-sm danger del" data-id="${m.cod_mobi_light}"><i class="fa-solid fa-trash"></i> Excluir</button>
        </td>
      </tr>
    `).join('');
    bind();
  }

  function bind() {
    grid.querySelectorAll('.edit').forEach(b =>
        b.onclick = () => editar(b.getAttribute('data-id'))
    );
    grid.querySelectorAll('.del').forEach(b =>
        b.onclick = () => excluir(b.getAttribute('data-id'))
    );
    grid.querySelectorAll('.vincular').forEach(b =>
        b.onclick = () => vincularEmpresa(b.getAttribute('data-id'))
    );
  }

  async function vincularEmpresa(id) {
  const empresas = (await api.get('/empresas')).data;

  Swal.fire({
    title: 'Vincular Empresa',
    html: `
      <form id="fVinculo" style="display:flex;flex-direction:column;gap:6px;text-align:left;">
        <label>Empresa
          <select name="cod_empresa" required class="swal2-input">
            ${empresas.map(e => `
              <option value="${e.cod_empresa}">${e.descricao}</option>
            `).join('')}
          </select>
        </label>
      </form>
    `,
    focusConfirm: false,
    showCancelButton: true,
    confirmButtonText: 'Salvar',
    cancelButtonText: 'Cancelar',
    preConfirm: async () => {
      const fd = new FormData(document.getElementById('fVinculo'));
      const payload = Object.fromEntries(fd.entries());
      try {
        await api.post('/mobilightempresas', { cod_mobi_light: id, cod_empresa: payload.cod_empresa });
        Swal.fire({ title: 'Vínculo salvo!', icon: 'success', timer: 1500, showConfirmButton: false });
        carregar();
      } catch (err) {
        Swal.showValidationMessage(err.response?.data?.message || 'Erro ao vincular empresa');
        return false;
      }
    }
  });
}


  async function excluir(id) {
    const result = await Swal.fire({
      title: 'Excluir equipamento?',
      text: 'Essa ação não poderá ser desfeita!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim, excluir',
      cancelButtonText: 'Cancelar'
    });
    if (!result.isConfirmed) return;
    await api.delete(`/mobilight/${id}`);
    Swal.fire({ title: 'Excluído!', icon: 'success', timer: 1500, showConfirmButton: false });
    carregar();
  }

  async function editar(id) {
    const mobi = id ? (await api.get('/mobilight')).data.find(x => x.cod_mobi_light === id) : null;
    const tipos = (await api.get('/tipomobilight')).data;

    Swal.fire({
      title: id ? 'Editar MobiLight' : 'Novo MobiLight',
      html: `
        <form id="fMobi" style="display:flex;flex-direction:column;gap:6px;text-align:left;">
          <label>Nº Série
            <input name="numero_serie" value="${mobi?.numero_serie || ''}" required class="swal2-input" />
          </label>
          <label>Tipo
            <select name="cod_tipo_mobi_light" required class="swal2-input">
              ${tipos.map(t => `
                <option value="${t.cod_tipo_mobi_light}" ${mobi?.cod_tipo_mobi_light === t.cod_tipo_mobi_light ? 'selected' : ''}>
                  ${t.descricao}
                </option>
              `).join('')}
            </select>
          </label>
          <label>Total Terapias
            <input name="total_terapias" type="number" value="${mobi?.total_terapias || 0}" class="swal2-input" />
          </label>
          <label>Total Horas
            <input name="total_horas" type="number" value="${mobi?.total_horas || 0}" class="swal2-input" />
          </label>
          <label>Limite Terapias
            <input name="limite_terapias" type="number" value="${mobi?.limite_terapias || 0}" class="swal2-input" />
          </label>
          <label>Limite Horas
            <input name="limite_horas" type="number" value="${mobi?.limite_horas || 0}" class="swal2-input" />
          </label>
          <label>Relação Motor
            <input name="relacaomotor" value="${mobi?.relacaomotor || ''}" class="swal2-input" />
          </label>
          <label>Motor
            <input name="motor" value="${mobi?.motor || ''}" class="swal2-input" />
          </label>
          <label>Driver
            <input name="driver" value="${mobi?.driver || ''}" class="swal2-input" />
          </label>
          <label>Versão SW
            <input name="versaosw" value="${mobi?.versaosw || ''}" class="swal2-input" />
          </label>
        </form>
      `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: 'Salvar',
      cancelButtonText: 'Cancelar',
      preConfirm: async () => {
        const fd = new FormData(document.getElementById('fMobi'));
        const payload = Object.fromEntries(fd.entries());
        try {
          if (id) {
            await api.put(`/mobilight/${id}`, payload);
          } else {
            await api.post('/mobilight', payload);
          }
          carregar();
        } catch (err) {
          Swal.showValidationMessage(err.response?.data?.message || 'Erro ao salvar MobiLight');
          return false;
        }
      }
    });
  }

  // Botões principais
  actions.querySelector('#btnCarregarMobi').onclick = carregar;
  actions.querySelector('#btnNovoMobi').onclick = () => editar();

  carregar();
  return container;
}
